<template>
  <div v-if="authenticatedUser">
    <b-container>
      <!-- Successful recipe share modal -->
      <b-modal id="modal-1" title="Success"
               ok-only>
        <p class="my-2">This resource is shared with the user you have chosen!</p>
      </b-modal>
      <b-modal id="modal-2" title="Success"
               ok-only>
        <p class="my-2">This resource is shared with the group you have chosen!</p>
      </b-modal>
      <!-- Share Resource  Modal -->
      <b-modal
        id="modal-prevent-closing"
        ref="modal"
        v-bind:title="'Share the resouce ' +this.title"
        ok-variant="danger"
        ok-title="Share"
        @cancel="hideModal"
        @ok="handleOk">

        <form ref="form" @submit.stop.prevent="handleSubmit">
          <div class="container">

            <b-form-group label="Do you wish to share this resource with a single user or a group?">
              <!--      <b-form-radio-group id="radio-group-2" v-model="selected" @input="consolee" name="radio-sub-component">-->
              <b-form-radio-group id="radio-group-2" v-model="selected" name="radio-sub-component">
                <b-form-radio value="a">a single user</b-form-radio>
                <b-form-radio value="b">a group</b-form-radio>
              </b-form-radio-group>
            </b-form-group>

            <b-form-group v-if="this.selected ==='a'">
              <p class="my-2">Whom would you like to share this with?</p>
              <Autocomplete :EventBus="sendChosenLogin1"></Autocomplete>
              <b-alert dismissible style="width: 100%" v-model="emptyLoginAlert" variant="danger">
                This login is invalid!
              </b-alert>
              <b-alert dismissible style="width: 100%" v-model="notFoundUserAlert" variant="danger">
                An error occured! Maybe the login you submitted does not exist!
              </b-alert>

            </b-form-group>

            <b-form-group v-if="this.selected ==='b'"

                          label="Which group would you like to share this resource with?" label-align="left">
              <b-form-input style="width: 100%"
                            v-model="GroupChosen" placeholder="Enter the Group name">
              </b-form-input>

              <b-alert dismissible style="width: 100%" v-model="emptyGroupNameAlert" variant="danger">
                This group name is invalid!
              </b-alert>
              <b-alert dismissible style="width: 100%" v-model="notFoundGroupAlert" variant="danger">
                An error occured! Maybe the group you submitted does not exist!
              </b-alert>

            </b-form-group>

          </div>

          <hr>

          <b-form-group
            class="col-12"
            label="What right will you grant to this user/group?" label-align="left">
            <b-form-select
              :options="Rights"
              v-model="right">
            </b-form-select>
            <b-alert dismissible style="width: 100%" v-model="emptyRightAlert" variant="danger">
              You have to specify the right!
            </b-alert>

          </b-form-group>
        </form>
      </b-modal>
      <!-- my resources -->
      <ResourcesSection :type="ownResourcesType"></ResourcesSection>
      <!-- shared resources -->
      <ResourcesSection :type="sharedResourcesType"></ResourcesSection>
    </b-container>
  </div>
  <div v-else>
    <NoAccess></NoAccess>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import ResourcesSection from '../components/resources/ResourcesSection'
import NoAccess from '../components/NoAccess'
import {eventBus} from '../main'
import axios from 'axios'
import Autocomplete from './Autocomplete'

export default {
  name: 'resources',
  data () {
    return {
      emptyLoginAlert: false,
      emptyRightAlert: false,
      notFoundUserAlert: false,
      ownResourcesType: 'OWN',
      sharedResourcesType: 'SHARE',
      resourceID: 0,
      ResourcesType: 'Resource',
      sendChosenLogin1: 'sendChosenLogin',
      selected: 'a',
      GroupChosen: '',
      GroupChosenId: '',

      title: '',
      userLogin: null,
      userID: 0,
      right: null,
      users: '',

      Rights: [
        {text: 'I will grant the right to ...', value: null},
        {text: 'View the resource', value: 'READ'},
        {text: 'Edit the resource', value: 'WRITE'}],

      value1: ''

    }
  },

  created () {
    eventBus.$on('shareResource', resourceID1 => {
      console.log('300' + resourceID1)
      this.resourceID = resourceID1[0]
      this.title = resourceID1[1]
      console.log(this.title)
      this.$bvModal.show('modal-prevent-closing')
    }),

    eventBus.$on('PrefixLoginData', PrefixLoginData => {
      console.log('300' + PrefixLoginData)
      this.cities = PrefixLoginData
    })

    eventBus.$on('sendChosenLogin', value11 => {
      this.value1 = value11
    })
    // console.log(value11)
  },
  methods: {
    handleOk (bvModalEvt) {
      // Prevent modal from closing
      console.log('10')
      bvModalEvt.preventDefault()
      // Trigger submit handler
      console.log('20')
      this.handleSubmit()
    },

    hideModal () {
      this.resourceID = 0
      this.value1 = ''
      this.right = null
      this.notFoundUserAlert = false
      this.notFoundGroupAlert = false
      this.emptyRightAlert = false
      this.emptyLoginAlert = false
      this.emptyGroupNameAlert = false
      this.selected = 'a'
      this.GroupChosen = ''
    },
    handleSubmit () {
      if (this.selected === 'b') {
        this.emptyRightAlert = false
        this.emptyGroupNameAlert = false
        this.notFoundGroupAlert = false

        // Exit when the form isn't valid
        console.log('30')
        console.log(this.GroupChosen)
        if (this.GroupChosen === null || this.GroupChosen === ''
        ) {
          this.emptyGroupNameAlert = true
        } else if (this.GroupChosen !== null && this.GroupChosen !== '') {
          this.emptyGroupNameAlert = false

          axios
            .get('/group/byName?name=' + this.GroupChosen, {
              withCredentials: true
            })
            .then(response => {
              console.log(response)
              this.GroupChosenId = response.data.id
              this.notFoundGroupAlert = false
              if (this.right === '' || this.right === null) {
                this.emptyRightAlert = true
              } else {
                this.SendUserDataToAPI()
              }
            })
            .catch((err) => {
              console.log(err)
              this.emptyGroupNameAlert = false
              this.notFoundGroupAlert = true
              this.userID = ''
            })
        }
      }

      if (this.selected === 'a') {
        this.emptyRightAlert = false
        this.emptyLoginAlert = false
        this.notFoundUserAlert = false

        // Exit when the form isn't valid
        console.log('31')
        console.log(this.value1)
        if (this.value1 === null || this.value1 === ''
        ) {
          this.emptyLoginAlert = true
          this.value1 = ''
        } else if (this.value1 !== null && this.value1 !== '') {
          this.emptyLoginAlert = false
          axios.get('/user/byLogin?login=' + this.value1,

            {withCredentials: true})
            .then(
              response => {
                console.log(response)
                this.userID = response.data.id
                this.notFoundUserAlert = false

                if (this.right === '' || this.right === null) {
                  this.emptyRightAlert = true
                } else {
                  this.SendUserDataToAPI()
                }
              })
            .catch((err) => {
              console.log(err)
              this.emptyLoginAlert = false
              this.notFoundUserAlert = true
              this.userID = ''
            }
            )
        }
      }
    },

    SendUserDataToAPI () {
      if (this.selected === 'a') {
        axios.post('/share/Resource/' + this.resourceID + '?userId=' + this.userID + '&right=' + this.right, null,

          {withCredentials: true})
          .then(
            response => {
              console.log(response)
              console.log(' response')
              this.resourceID = 0
              this.value1 = ''
              this.right = null
              this.notFoundUserAlert = false
              this.emptyRightAlert = false
              this.emptyLoginAlert = false
              this.$bvModal.hide('modal-prevent-closing')
              this.$bvModal.show('modal-1')
            }
          )
      }

      if (this.selected === 'b') {
        axios.post('/share/Resource/' + this.resourceID + '?groupId=' + this.GroupChosenId + '&right=' + this.right, null,

          {withCredentials: true})
          .then(
            response => {
              console.log(response)
              console.log(' response')
              this.resourceID = 0
              this.GroupChosenId = ''
              this.value1 = ''
              this.right = null
              this.notFoundUserAlert = false
              this.emptyRightAlert = false
              this.emptyLoginAlert = false
              this.$bvModal.hide('modal-prevent-closing')
              this.$bvModal.show('modal-2')
            }
          )
      }
    }

  },

  components: {
    ResourcesSection,
    Autocomplete,
    NoAccess
  },
  computed: {
    ...mapGetters([
      'authenticatedUser'
    ])
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Resources.vue